export const urls: any = {
  additional_information: '/api/additional_information',
  essential: '/api/essential',
  internal_ids: '/api/internal_ids',
  import_records: '/api/import_records'
}

export default urls
